import { ServiceCode } from '@/shared/types';

import { SERVICE_CODES } from '@/lib/consts';

// TODO: move to generated dictionaries from /services endpoint
export const ServiceNames: Record<ServiceCode, string> = {
  [SERVICE_CODES.ERZ_EXTRACT]: 'Отримання витягу з реєстру зброї',
  [SERVICE_CODES.ERZ_SEARCH]: 'Перевірка витягу з Єдиного реєстру зброї',
  [SERVICE_CODES.VALIDITY_PERIOD_PROLONGATION]: 'Заява про отримання дозволу на продовження терміну дії дозволу',
  [SERVICE_CODES.RESIDENCE_RELOCATION]: 'Заява про зміну місця проживання власника зброї',
  [SERVICE_CODES.TEMPORARY_RESIDENCE_RELOCATION]: 'Заява про тимчасову зміну місця проживання власника зброї',
  [SERVICE_CODES.CANCELLATION_TEMPORARY_RESIDENCE_RELOCATION]:
    'Заява на повернення після тимчасової зміни місця зберігання зброї',
  [SERVICE_CODES.COLD_STEEL_TRANSPORTATION]:
    'Заява про отримання дозволу на перевезення холодної колекційної зброї територією України',
  [SERVICE_CODES.COMMISSION_SALE]:
    'Подання заяви про надання направлення на комісійний продаж вогнепальної мисливської зброї, основних частин зброї, пневматичної, холодної, охолощеної зброї, пристроїв',
  [SERVICE_CODES.PURCHASE]: 'Заява про надання дозволу на придбання',
  [SERVICE_CODES.STORAGE_CARRYING]:
    'Подання заяви про надання дозволу на зберігання, носіння вогнепальної мисливської зброї, основних частин зброї, пневматичної, холодної, охолощеної зброї, пристроїв, крім нагородної',
  [SERVICE_CODES.TRANSPORT_ACROSS_BORDER]:
    'Заява про надання дозволу на перевезення зброї через митний кордон України (вивезення - ввезення)',
  [SERVICE_CODES.MISSING_PERSON]:
    'Подача анкети про зниклу особу безвісти за особливих обставин до уповноваженого з питань осіб зниклих безвісти за особливих обставин',
  [SERVICE_CODES.COLD_STEEL_STORAGE_FOR_COLLECTION]:
    'Заява на отримання дозволу на зберігання холодної зброї з метою колекціонування',
  [SERVICE_CODES.CRIMINAL_RECORD_SEARCH]: 'Перевірка витягу про наявність судимості',
  [SERVICE_CODES.CRIMINAL_RECORD_SEARCH_ALL]: 'Мої витяги про несудимість',
  [SERVICE_CODES.SOCIAL_PROTECT]: 'Соціальний захист',
  [SERVICE_CODES.INSURANCE]: 'Страхування для власників зброї',
  [SERVICE_CODES.PAYMENT_WITHOUT_APPLICATION]: 'Оплата послуг',
  [SERVICE_CODES.CITIZEN_APPEAL_TO_MVS]: 'Подання електронного звернення',
  [SERVICE_CODES.MISSING_PASSPORT]: 'Сервіс пошуку паспорту серед втрачених та викрадених',
  [SERVICE_CODES.MISSING_PHONE]: 'Мобільні телефони',
  [SERVICE_CODES.WANTED_WEAPON]: 'Зброя у розшуку',
  [SERVICE_CODES.WANTED_ART]: 'Культурні цінності',
  [SERVICE_CODES.MISSING_INCAPACITATED_PERSONS]:
    'Особи, що не можуть надати про себе відомостей внаслідок хвороби або неповнолітнього віку',
  [SERVICE_CODES.MISSING_CORPSES]: 'Померлі, особи яких не встановлені',
  [SERVICE_CODES.WANTED_PERSON_SEARCH]: 'Пошук осіб, які переховуються від органів влади',
  [SERVICE_CODES.MISSING_PERSON_SEARCH]: 'Зниклі громадяни',
  [SERVICE_CODES.MISSING_CHILDREN_SEARCH]: 'Зниклі діти',
  [SERVICE_CODES.VEHICLE_SEARCH]: 'Пошук транспортного засобу',
  [SERVICE_CODES.CHECK_EXTRACT_VERIFICATION]:
    'Перевірка витягу з Єдиного реєстру осіб, зниклих безвісти за особливих обставин',
  [SERVICE_CODES.EXTENDED_CRIMINAL_RECORD_EXTRACT]: 'Отримання витягу про несудимість, зокрема з апостилем і доставкою',
  [SERVICE_CODES.MISSING_PERSON_EXTRACT]:
    'Запит на отримання витягу з Єдиного реєстру осіб, зниклих безвісти за особливих обставин',
  [SERVICE_CODES.SEARCH_INCOMING_CORRESPONDENCE]: 'Пошук вхідної кореспонденції',
  [SERVICE_CODES.EXTRACT_REDELIVERY]: 'Повторна доставка витягу про несудимість',
  [SERVICE_CODES.REAPPLICATION]: 'Повторне подання заяви на витяг з реєстру зброї',
  [SERVICE_CODES.TATTOO_SEARCH]: 'Пошук по татуюванням',
};

export enum StepsNavigationName {
  extractFormType = 'Форма витягу',
  serviceDescription = 'Опис послуги',
  coldWeapons = 'Дані по холодній зброї',
  weaponData = 'Дані про зброю',
  permissionData = 'Дані про дозвіл',
  expertResearch = 'Дані експертних досліджень',
  paymentData = 'Дані для оплати',
  personalData = 'Особисті дані',
  personalAndPassport = 'Особисті та паспортні дані',
  currentPlaceOfResidence = 'Поточне місце проживання (зберігання зброї)',
  birthAndRegistrationAddress = 'Місце народження та реєстрації',
  birthAddress = 'Місце народження',
  purposeAndExtractType = 'Мета запиту і тип витягу',
  payment = 'Оплата',
  contractSecurityActivities = "Дані про договір із суб'єктом охоронної діяльності або поліцією охорони",
  additionalDocument = 'Додаткові відомості та документи',
  confirmationOfApplication = 'Підтвердження даних заяви',
  directionOfTransportation = 'Дані про напрямок перевезення',
  transportAndRoute = 'Дані про транспорт та маршрут',
  technicalCondition = 'Документ про огляд технічного стану та відстріл',
  insurance = 'Дані про страхування',
  newAddressOfResidence = 'Нова адреса місця проживання (зберігання зброї)',
  newTemporaryAddressOfResidence = 'Адреса тимчасового місця зберігання зброї',
  objectOfPurchase = 'Вибір предмету придбання',
  personStatusTraumaticDevices = 'Статус особи (для придбання пристроїв травматичної дії)',
  personStatus = 'Статус особи',
  materialPartsOfWeapons = 'Дані про вивчення матеріальної частини зброї, правил поводження та застосування (крім газової зброї та основних частин зброї)',
  health = 'Дані про стан здоров’я',
  personalMissingPerson = 'Особисті дані зниклої особи',
  addressMissingPerson = 'Адреса реєстрації та проживання зниклої особи',
  informationDisappearance = 'Інформація про зникнення',
  informationCriminalProceedings = 'Відомості про кримінальне провадження',
  informationApplicant = 'Відомості про заявника',
  confirmationOfQuestionnaire = 'Підтвердження даних анкети',
  signUp = 'Підписання документу КЕП',
  result = 'Результат',
  delivery = 'Доставка',
}
